import { customerRecord } from "./operations.js";
import { orderTotal } from "./model.js";
export function filteredOrders(d, query = "", filter = "All") {
  return d.orders.filter(
    (o) =>
      `${o.id} ${d.customers.find((c) => c.id === o.customerId)?.name || ""} ${o.items.map((i) => i.name || "").join(" ")}`
        .toLowerCase()
        .includes(query.toLowerCase()) &&
      (filter === "All" || o.status === filter),
  );
}
export function filteredPayments(d, query = "", filter = "All") {
  return d.payments.filter(
    (p) =>
      `${p.id} ${p.orderId} ${d.customers.find((c) => c.id === d.orders.find((o) => o.id === p.orderId)?.customerId)?.name || ""}`
        .toLowerCase()
        .includes(query.toLowerCase()) &&
      (filter === "All" || p.status === filter),
  );
}
export function filteredCustomers(d, query = "", filter = "All") {
  return d.customers.filter((c) => {
    const r = customerRecord(d, c);
    return (
      `${r.id} ${r.name} ${r.email} ${r.phone} ${r.city || ""} ${r.address} ${r.note || ""} ${r.status} ${r.registration}`
        .toLowerCase()
        .includes(query.toLowerCase()) &&
      (filter === "All" || r.status === filter)
    );
  });
}
export function dateOnly(value) {
  if (!value) return "";
  const s = String(value);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s))
    return Number.isFinite(Date.parse(s)) &&
      new Date(s).toISOString().slice(0, 10) === s
      ? s
      : "";
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? "" : d.toISOString().slice(0, 10);
}
const amount = (n) =>
  typeof n === "number" && Number.isFinite(n) ? Math.round(n * 100) / 100 : "";
export function cell(value) {
  let s = value == null ? "" : String(value);
  if (
    typeof value === "string" &&
    (/^[\s\u0000-\u001f]*[=+@-]/.test(s) || /^[\t\r\n]/.test(s))
  )
    s = "'" + s;
  return '"' + s.replaceAll('"', '""') + '"';
}
export function csv(headers, rows) {
  return (
    "\uFEFF" +
    [headers, ...rows].map((row) => row.map(cell).join(",")).join("\r\n") +
    "\r\n"
  );
}
export function exportRows(section, d, query = "", filter = "All") {
  if (section === "orders") {
    const records = filteredOrders(d, query, filter);
    return {
      headers: [
        "Order ID",
        "Order date",
        "Customer name",
        "Customer email",
        "Items summary",
        "Merchandise subtotal",
        "Discount",
        "Shipping charge",
        "Total",
        "Currency",
        "Payment status",
        "Fulfilment status",
        "Courier",
        "Tracking number",
      ],
      rows: records.map((o) => {
        const c = d.customers.find((c) => c.id === o.customerId),
          p = d.payments.find((p) => p.id === o.paymentId);
        return [
          o.id,
          dateOnly(o.date),
          c?.name || "",
          c?.email || "",
          o.items
            .map(
              (i) =>
                `${i.name || d.products.find((p) => p.id === i.productId)?.name || "Historical item"} × ${i.qty}${i.sku ? " (" + i.sku + ")" : ""}`,
            )
            .join("; "),
          amount(o.items.reduce((sum, i) => sum + i.price * i.qty, 0)),
          amount(o.discount ?? 0),
          amount(o.shipping ?? 0),
          amount(orderTotal(o)),
          o.settingsSnapshot?.currency || d.settings.currency || "INR",
          p?.status || "",
          o.status,
          o.carrier || "",
          o.tracking || "",
        ];
      }),
    };
  }
  if (section === "payments") {
    const records = filteredPayments(d, query, filter);
    return {
      headers: [
        "Payment ID",
        "Payment reference",
        "Order ID",
        "Customer name",
        "Transaction date",
        "Payment method",
        "Amount",
        "Currency",
        "Payment status",
      ],
      rows: records.map((p) => {
        const o = d.orders.find((o) => o.id === p.orderId),
          c = d.customers.find((c) => c.id === o?.customerId);
        return [
          p.id,
          p.reference || "",
          p.orderId || "",
          c?.name || "",
          dateOnly(p.date),
          p.method || "",
          amount(p.amount ?? (o ? orderTotal(o) : null)),
          o?.settingsSnapshot?.currency || d.settings.currency || "INR",
          p.status,
        ];
      }),
    };
  }
  if (section === "customers") {
    const records = filteredCustomers(d, query, filter);
    return {
      headers: [
        "Customer ID",
        "Name",
        "Email",
        "Phone",
        "City",
        "Address",
        "Order count",
        "Signup date",
        "Account status",
        "Non-cancelled order value",
        "Currency",
        "Support notes",
        "Example record",
      ],
      rows: records.map((c) => {
        const r = customerRecord(d, c);
        return [
          r.id,
          r.name,
          r.email || "",
          r.phone || "",
          r.city || "",
          r.address,
          r.orderCount,
          dateOnly(r.registration),
          r.status,
          amount(r.orderValue),
          d.settings.currency || "INR",
          r.note || "",
          r.exampleRecord ? "Yes" : "No",
        ];
      }),
    };
  }
  throw Error("Unknown export section.");
}
export function makeExport(
  section,
  d,
  query = "",
  filter = "All",
  now = new Date(),
) {
  const { headers, rows } = exportRows(section, d, query, filter);
  return {
    content: csv(headers, rows),
    count: rows.length,
    filename: `praachin-${section}-${now.toISOString().slice(0, 10)}.csv`,
  };
}
export function downloadExport(file) {
  if (!file.count)
    throw Error(
      "No matching records to export. Clear or change your search and filters.",
    );
  const blob = new Blob([file.content], { type: "text/csv;charset=utf-8" }),
    url = URL.createObjectURL(blob),
    a = document.createElement("a");
  a.href = url;
  a.download = file.filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
